import carbonLabelSalesPromptStories from "./CarbonLabelsSalesPrompt.stories";
import recipePageLabelStories from "./RecipePageLabel.stories";

const stories = {
  name: "labels",
  children: [carbonLabelSalesPromptStories, recipePageLabelStories],
};

export default stories;
